import { Box, Typography } from '@mui/material'
import useScreenWidth from '../../../../../shared/hooks/useScreenWidth'

interface CoverSectionProps {
  seminar: {
    title: string
    description: string
    cover: string
    lessons: any[]
  }
  seminarlesson_selected: any
}

const CoverSection = ({ seminar, seminarlesson_selected }: CoverSectionProps) => {
  const isMobile = useScreenWidth(700)
  const isLaptop = useScreenWidth(1024)

  const shouldShowCover = seminarlesson_selected === null && (seminar.lessons.length > 1 || seminar.lessons.length === 0)

  if (!shouldShowCover) return null

  return (
    <Box display="flex" gap={24} data-testid="seminar-cover" flexWrap={isLaptop || isMobile ? 'wrap' : 'nowrap'}>
      <Box
        aria-details={seminar.title}
        height={isMobile ? 210 : 300}
        width={isLaptop || isMobile ? '50%' : '100%'}
        style={{
          backgroundImage: `url(${import.meta.env.VITE_AWS_URL}/seminars/${seminar.cover})`,
          backgroundPosition: 'center center',
          backgroundSize: 'cover'
        }}
      />
      <Box width={isLaptop || isMobile ? '100%' : '50%'}>
        <Typography>{seminar.description}</Typography>
      </Box>
    </Box>
  )
}

export default CoverSection
